package br.com.texeratx.boardgametimeapp.ui.screens.games.model

data class GameCategoryUI(
    val id: Long,
    val name: String
)

